import { Component, inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { KeeniconComponent } from '../../keenicon/keenicon.component';

@Component({
	selector: 'app-delete',
	templateUrl: './delete.component.html',
	styleUrls: ['./delete.component.scss'],
	imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, ToastrModule, KeeniconComponent],
	standalone: true,
})
export class DeleteComponent implements OnInit {
	@Input() values: any;
	typeTitle!: string;
	itemName!: string;
	msg!: string;

	readonly dialogRef = inject(MatDialogRef) as MatDialogRef<DeleteComponent>;
	readonly data = inject(MAT_DIALOG_DATA) as any;

	ngOnInit() {
		if (this.data && this.data.type) {
			this.typeTitle = this.data.type;
			this.itemName = this.data.item;
			this.msg = this.data.msg;
		}
	}

	cancelDelete(): void {
		this.dialogRef.close(false);
	}

	deleteConfirm() {
		this.dialogRef.close(true);
	}
}
